import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';
import { Observable } from 'rxjs';
import { AttributeEditorMode } from '../../models/attributes/attributeEditorMode';
import { ComplexAttributeWrite } from '../../models/attributes/complexAttributeWrite';

@Component({
  selector: 'custom-fields-inline-editor',
  templateUrl: './custom-fields-inline-editor.component.html',
  styleUrls: ['./custom-fields-inline-editor.component.scss'],
  standalone: false
})
export class CustomFieldsInlineEditorComponent {
  /** only used for documents */
  @Input()
  entityId: string = '';
  @Input() attributeEditorMode: AttributeEditorMode = AttributeEditorMode.PersonDetails;
  @Input()
  editable: boolean = true;
  @Input()
  noValueText: string = '';
  @Input()
  useDescription: boolean = false;
  @Input()
  showEmpty: boolean = true;
  @Input()
  customFields: AttributeDefinition[];
  @Input()
  customFieldValues: Attribute[];
  @Input()
  saveFn: (attributeDefinitionId: string, attributeWrite: AttributeWrite) => Promise<boolean>;
  @Input()
  deleteFn: (attributeDefinitionId: string) => Observable<any>;
  @Output()
  addOrUpdateComplexValue: EventEmitter<{
    attributeDefinitionId: string;
    writeModel: ComplexAttributeWrite[];
  }> = new EventEmitter<{ attributeDefinitionId: string; writeModel: ComplexAttributeWrite[] }>();

  public filtered(): AttributeDefinition[] {
    if (this.showEmpty) {
      return this.customFields;
    }
    return this.filterForNonEmpty();
  }

  private filterForNonEmpty(): AttributeDefinition[] {
    if (!this.customFields) return [];
    return this.customFields.filter(
      (cf) => this.customFieldValues.filter((a) => a.attributeDefinitionId == cf.id).length
    );
  }
}
